(function() {
    /*
    * Adds animation to an element
    *
    * params:
    * element
    * options
    */
    function addScrollAnimation(element, options) {

        let offsetTop;
        let timer;

        if(!element) {
            return;
        } else {
            offsetTop = getElementOffsetTop(element);
        }

        setTransform(element, options, offsetTop);

        window.addEventListener("scroll", function() {
            if(timer) {
                window.clearTimeout(timer);
            }

            timer = window.setTimeout(function() {
                setTransform(element, options, offsetTop);
            }, 10);
        }, false);
    }

    function getElementOffsetTop(element) {
        let top = 0;

        do {
            top += element.offsetTop || 0;
            element = element.offsetParent;
        } while (element);

        return top;
    }

    function setTransform(element, options, offsetTop) {
        let scroll = window.scrollY - offsetTop;
        let translate = scroll + window.innerHeight;
        let transform = [];

        options.forEach(o => {
            transform.push(`${o.transform}(${(translate + o.offset) * o.speed}${o.unit})`);
        })


        element.style.transform = transform.join(' ');
    }

    document.querySelectorAll("[data-scroll-animation]").forEach(element => {
        let options = JSON.parse(element.dataset.scrollAnimation);
        addScrollAnimation(element, options);
    });

}());